module.exports = __webpack_public_path__ + "components/rewards/dogtag/static/logo-e46775a1c6117c6794996329e1b26bc4.jpg";